import { render, staticRenderFns } from "./kpis-success.component.vue?vue&type=template&id=1a3d94a0&scoped=true"
import script from "./kpis-success.component.vue?vue&type=script&lang=ts"
export * from "./kpis-success.component.vue?vue&type=script&lang=ts"
import style0 from "./kpis-success.component.vue?vue&type=style&index=0&id=1a3d94a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3d94a0",
  null
  
)

export default component.exports